import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export const Preloader = () => {
  const [done, setDone] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setDone(true), 1900);
    return () => clearTimeout(t);
  }, []);

  return (
    <motion.div
      data-testid="preloader"
      initial={{ opacity: 1 }}
      animate={done ? { opacity: 0 } : { opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.65, 0, 0.35, 1] }}
      style={{ pointerEvents: done ? "none" : "auto" }}
      className="fixed inset-0 z-[100] bg-ink flex items-center justify-center"
    >
      <div className="overflow-hidden">
        <motion.div
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, ease: [0.65, 0, 0.35, 1] }}
          className="font-display italic text-glacier text-3xl sm:text-4xl tracking-wide"
        >
          64°N — Islandia
        </motion.div>
      </div>
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.7, ease: [0.65, 0, 0.35, 1] }}
        className="absolute bottom-0 left-0 h-[2px] w-full origin-left bg-glacier/70"
        style={{ backgroundColor: "var(--glacier)" }}
      />
    </motion.div>
  );
};
